import React, { Component } from 'react';
import { connect } from 'react-redux';
import { usersUtil, TYPES } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';
import AllRecentActivity from 'components/admin/recent-activity/AllRecentActivity';
import SpeRecentActivity from 'components/admin/recent-activity/SpeRecentActivity';
import SwRecentActivity from 'components/admin/recent-activity/SwRecentActivity';

class DashboardRecentActiviy extends Component {
  constructor(props) {
    super(props);

    this.client = usersUtil.hasType(props.currentUser, TYPES.CLIENT);
    this.subcontractor = usersUtil.hasType(props.currentUser, TYPES.CONTRACTOR);
  }

  render() {
    return this.client || this.subcontractor ? (
      <React.Fragment>
        <SpeRecentActivity />
        <SwRecentActivity />
      </React.Fragment>
    ) : (
      <AllRecentActivity />
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
  };
})(DashboardRecentActiviy);



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/DashboardRecentActivity.js